import { useLayoutEffect, useRef } from "react"

/**
 * 다시 그린 뒤 커서를 사람이 보던 자리에 돌려놓는다.
 *
 * 하이픈이 붙거나 떨어지면 글자 수가 달라져, 그냥 두면 커서가 칸 끝으로 튄다.
 * `setCaret(위치)` 를 부른 편집만 되돌리고(다른 렌더에서는 손대지 않는다),
 * 포커스가 그 칸에 있을 때만 옮긴다.
 */
export function useCaretRestore<T extends HTMLInputElement>() {
  const ref = useRef<T>(null)
  const caretRef = useRef<number | null>(null)

  useLayoutEffect(() => {
    const input = ref.current
    const caret = caretRef.current
    caretRef.current = null
    if (input && caret !== null && document.activeElement === input) {
      input.setSelectionRange(caret, caret)
    }
  })

  return {
    ref,
    setCaret: (caret: number) => {
      caretRef.current = caret
    },
  }
}
